import React from 'react'
import Table from 'shared/components/Table'
import Popup from 'shared/components/Popup'
import { Label, Dropdown } from 'semantic-ui-react'
import { capitalize } from 'lodash'

interface RoleData {
  id: number
  name: string
  user_count: number
  is_predefined: boolean
}

interface RoleTableProps {
  dataSource: RoleData[]
  handleEdit: (roleId: number, roleName: string, isPredefined: boolean) => void
  handleDelete: (roleId: number) => void
  hasManageRolePermission: boolean
}

const RoleTable: React.FC<RoleTableProps> = ({
  dataSource,
  handleEdit,
  handleDelete,
  hasManageRolePermission,
}) => {
  const columns = [
    {
      title: 'Role',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: 120,
      render(_, data) {
        return (
          <div className="flex items-center">
            <Popup
              basic
              disabled={!data.description}
              tooltip={<div>{data.description}</div>}
              size="mini"
              wide
              inverted
            >
              <div className="truncate">
                {data.is_predefined ? capitalize(data.name) : data.name}
              </div>
            </Popup>
          </div>
        )
      },
      sorter(dataA, dataB) {
        const labelA = dataA.name
        const labelB = dataB.name
        return (labelA || '').localeCompare(labelB)
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Users',
      dataIndex: 'user_count',
      key: 'user_count',
      align: 'right',
      width: 50,
      render(_, data) {
        return <div>{data.user_count}</div>
      },
      sorter(dataA, dataB) {
        const valueA = dataA.user_count
        const valueB = dataB.user_count

        return valueA - valueB
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Source',
      dataIndex: 'is_predefined',
      key: 'is_predefined',
      width: 80,
      render(_, data) {
        return (
          <div className="flex items-center">
            <Label basic>{data.is_predefined ? 'Default' : 'Custom'}</Label>
          </div>
        )
      },
      sorter(dataA, dataB) {
        return dataA.is_predefined - dataB.is_predefined
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: '',
      key: 'action',
      align: 'right',
      width: 30,
      render(_, data) {
        const roleName = data.is_predefined ? capitalize(data.name) : data.name
        return (
          <Dropdown
            icon="far fa-ellipsis-vertical"
            floating
            pointing="top right"
            className="table-elipsis-toolbar-dropdown"
          >
            <Dropdown.Menu>
              <React.Fragment>
                <React.Fragment>
                  <Dropdown.Item
                    text="Edit"
                    icon="far fa-edit"
                    onClick={() => handleEdit(data.id, roleName, data.is_predefined)}
                  />
                  {hasManageRolePermission && !data.is_predefined && (
                    <Dropdown.Item
                      className="!text-negative"
                      text="Delete"
                      icon="far fa-trash-can"
                      onClick={() => handleDelete(data.id)}
                    />
                  )}
                </React.Fragment>
              </React.Fragment>
            </Dropdown.Menu>
          </Dropdown>
        )
      },
    },
  ]
  return (
    <div>
      <Table
        variant="indexPage"
        clickable={false}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
    </div>
  )
}

export default RoleTable



// WEBPACK FOOTER //
// ./src/pages/Admin/Roles/RoleTable.tsx